import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { styled } from '@egoist/vue-emotion'
import * as getters from '../../../../builder/src/js/store/modules/getters'
import * as actions from '../../../../builder/src/js/store/modules/actions'
import * as constants from '../../../../builder/src/js/common/constants/constants'
import { mapGetters, mapState, mapActions } from 'vuex'
import CvtButton from '../../molecules/Button'
import CvtInput from '../../molecules/Input'
import CvtSelect from '../../molecules/Select'
import CvtRadioGroup from '../../molecules/radio-group/RadioGroup'
import CvtCustomCheckbox from '../../molecules/CustomCheckbox'
import { IntegrationReady } from './integration-ready'
import { IntegrationDescription } from './integration-description'
Vue.use(VueI18n)

let textFontWeight, textFontSize, Spacing, FontSize, backgroundColor, Colors

const getAuthenticationDescription = () => styled('div')`
  background: ${Colors.BASIC[100]};
`

const getHorizontalLine = () => styled('div')`
  border-top: 1px solid ${Colors.BASIC[300]};
  margin-bottom: 15px;
`

const getAuthSuccessBtnWrap = () => styled('div')`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`

const getInput = () => styled(CvtInput)`
  margin-bottom: 23px;
  > div {
    border-radius: 4px;
    border: 2px solid ${Colors.BASIC[300]};
  }
  > div > div {
    border-radius: 0;
    border: 0;
  }
`

const getSelect = () => styled(CvtSelect)`
  width: 100%;
  margin-bottom: 23px;

  > div {
    border-radius: 4px;
  }

  div > div {
    border-radius: 0;
    border: 0;
  }
`

const getFieldsCaption = () => styled('p')`
  font-size: 14px;
`

const getAuthDescriptionHeader = () => styled('p')`
  font-weight: 700;
  font-size: 14px;
  color: ${Colors.BASIC[500]};
`

const getCustomCheckbox = () => styled(CvtCustomCheckbox)``

const getCheckboxWrap = () => styled('div')`
  background: white;
  padding: 4px 7px;
  border-radius: 4px;
`

const getCheckboxContainer = () => styled('div')`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
`

export const MailchimpIntegration = {
  name: 'MailchimpIntegration',
  components: {
    CvtRadioGroup,
  },
  data() {
    return {
      mailchimpFields: [1, 2, 3],
      showPipelineSelect: false,
    }
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters({
      config: getters.AUTH_GET_USER_CONFIG,
      selectedIntegration: getters.SELECTED_INTEGRATION,
      currentStep: getters.GET_INTEGRATIONS_AUTH_STEP,
      formFieldGroups: getters.FORM_EDITOR_FIELD_GROUPS,
    }),
    ...mapGetters('globalTheme', {
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
    }),
    ...mapState('globalTheme', {
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontSize: ({ globalTheme }) => globalTheme.FontSize,
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      globalTheme: ({ globalTheme }) => globalTheme,
    }),

    getHubspotDefaultOptions() {
      return ['Option 1', 'Option 2', 'Option 3']
    },

    getMailchimpDefaultOptions() {
      return ['List 1', 'List 2', 'List 3']
    },

    getStaticTagDefaultOptions() {
      return ['Tag 1', 'Tag 2', 'Tag 3']
    },

    getConvrrtFormFields() {
      return this.formFieldGroups[0].fields || []
    },
  },
  created() {
    textFontSize = this.textFontSize
    textFontWeight = this.textFontWeight
    Spacing = this.Spacing
    FontSize = this.FontSize
    backgroundColor = this.backgroundColor
    Colors = this.Colors
  },
  mounted() {
    this.onScrollInToView()
  },
  methods: {
    ...mapActions('globalTheme', {}),
    ...mapActions({
      onChangeStep: actions.UPDATE_INTEGRATIONS_AUTH_STEP,
      onChangeScreen: actions.UPDATE_INTEGRATIONS_CURRENT_SCREEN,
    }),

    onScrollInToView() {
      const container = document.getElementById('authWrap')
      container.scrollIntoView()
    },

    onStepToIntegrationsScreen() {
      this.onChangeScreen(constants.INTEGRATIONS)
    },

    onChangeAuthStep(step: string) {
      this.onChangeStep(step)
      this.onScrollInToView()
    },

    onCheckDeal() {
      this.showPipelineSelect = !this.showPipelineSelect
    },
  },
  render: function (h) {
    const AuthenticationDescription = getAuthenticationDescription()
    const HorizontalLine = getHorizontalLine()
    const AuthSuccessBtnWrap = getAuthSuccessBtnWrap()
    const Input = getInput()
    const Select = getSelect()
    const FieldsCaption = getFieldsCaption()
    const AuthDescriptionHeader = getAuthDescriptionHeader()

    const CustomCheckbox = getCustomCheckbox()
    const CheckboxWrap = getCheckboxWrap()
    const CheckboxContainer = getCheckboxContainer()

    const optionElement = (idx, optionItem) => (
      <option id={idx} value={optionItem}>
        {optionItem}
      </option>
    )

    const getMailchimpOptions = this.getHubspotDefaultOptions.map(
      (option, index) => {
        return optionElement(index, option)
      },
    )

    const getListOptions = this.getMailchimpDefaultOptions.map(
      (option, index) => {
        return optionElement(index, option)
      },
    )

    const getStaticTagOptions = this.getStaticTagDefaultOptions.map(
      (option, index) => {
        return optionElement(index, option)
      },
    )

    return (
      <div style="width: 100%;">
        {this.currentStep === constants.AUTH_INIT && <IntegrationDescription />}

        {this.currentStep === constants.AUTH_SUCCESS && (
          <div>
            <AuthenticationDescription>
              <div style="padding: 45px;">
                <div>
                  <AuthDescriptionHeader>Choose a list</AuthDescriptionHeader>
                  <p>Select the list you want to add information to</p>
                  <Select placeholder="Please select">{getListOptions}</Select>
                </div>

                <div>
                  <HorizontalLine></HorizontalLine>
                  <p>Tags</p>
                  <Select placeholder="Static Tagging">
                    {getStaticTagOptions}
                  </Select>

                  <p style="font-size: 14px;">
                    You can select tags from the list below. Selected tags will
                    applied to all new contacts created through this form.
                  </p>

                  <CheckboxContainer style="">
                    <CheckboxWrap>
                      <CustomCheckbox
                        fontSize="14px"
                        label="Tag 1"
                        checked={false}
                      />
                    </CheckboxWrap>
                    <CheckboxWrap>
                      <CustomCheckbox
                        fontSize="14px"
                        label="Tag 2"
                        checked={false}
                      />
                    </CheckboxWrap>
                    <CheckboxWrap>
                      <CustomCheckbox
                        fontSize="14px"
                        label="Tag 3"
                        checked={false}
                      />
                    </CheckboxWrap>
                  </CheckboxContainer>

                  <HorizontalLine></HorizontalLine>
                  <AuthDescriptionHeader>
                    Match your fields
                  </AuthDescriptionHeader>

                  <div style="display: flex;gap: 30px;">
                    <div style="flex:1;">
                      <FieldsCaption>Your Convrrt Form Field</FieldsCaption>

                      <div>
                        {this.getConvrrtFormFields.map((field) => (
                          <Input
                            label=""
                            size="small"
                            mode={this.mode}
                            color="black"
                            placeholder={field.label}
                            value={''}
                            onClear={() => {}}
                            onInput={(e) => {}}
                          ></Input>
                        ))}
                      </div>
                    </div>

                    <div style="flex:1;">
                      <FieldsCaption>Desired Mailchimp Field</FieldsCaption>

                      <div>
                        {this.mailchimpFields.map(() => (
                          <Select placeholder="Client Name">
                            {getMailchimpOptions}
                          </Select>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AuthenticationDescription>

            <AuthSuccessBtnWrap>
              <CvtButton
                text="Cancel"
                outlined={true}
                specialPadding="12px"
                color="light"
                onClick={() => {}}
              ></CvtButton>
              <CvtButton
                text="Save"
                outlined={true}
                specialPadding="12px"
                disabled={false}
                color="success"
                onClick={() =>
                  this.onChangeAuthStep(constants.INTEGRATION_COMPLETE)
                }
              ></CvtButton>
            </AuthSuccessBtnWrap>
          </div>
        )}

        {this.currentStep === constants.INTEGRATION_COMPLETE && (
          <IntegrationReady />
        )}
      </div>
    )
  },
}
